/* PURE SKY - Interactive Hotspot Section JavaScript */

// ========================================
// HOTSPOT DATA
// ========================================

const hotspotProducts = {
  1: {
    id: 1,
    title: 'Glass Cleaning Cloth',
    price: 14.99,
    comparePrice: null,
    rating: 4.9,
    reviewCount: 342,
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=600&q=80',
    images: [
      'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80',
      'https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=800&q=80',
      'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=800&q=80'
    ],
    description: 'Experience the magic of water-only cleaning with our premium microfiber glass cloth. Designed to deliver streak-free shine on windows, mirrors, and glass surfaces without any chemicals.',
    badge: 'NEW',
    variants: [
      { name: 'Blue', image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=100&q=80' },
      { name: 'Gray', image: 'https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=100&q=80' },
      { name: 'White', image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=100&q=80' }
    ]
  },
  2: {
    id: 2,
    title: 'Kitchen Essentials Kit',
    price: 39.99,
    comparePrice: 49.99,
    rating: 4.8,
    reviewCount: 567,
    image: 'https://images.unsplash.com/photo-1585659722983-3a675dabf23d?w=600&q=80',
    images: [
      'https://images.unsplash.com/photo-1585659722983-3a675dabf23d?w=800&q=80',
      'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80',
      'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=800&q=80'
    ],
    description: 'The complete kitchen cleaning solution. Includes specialized cloths for countertops, dishes, and stainless steel appliances. Everything you need for a sparkling clean kitchen.',
    badge: 'SAVE 20%',
    badgeType: 'sale',
    variants: [
      { name: 'Multi-Color', image: 'https://images.unsplash.com/photo-1585659722983-3a675dabf23d?w=100&q=80' },
      { name: 'Neutral', image: 'https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=100&q=80' }
    ]
  },
  3: {
    id: 3,
    title: 'Dusting Cloth Set',
    price: 24.99,
    comparePrice: null,
    rating: 4.9,
    reviewCount: 234,
    image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=600&q=80',
    images: [
      'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=800&q=80',
      'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=800&q=80'
    ],
    description: 'Say goodbye to dust and allergens. Our premium dusting cloths trap and hold dust particles without spreading them around. Perfect for all surfaces including electronics and furniture.',
    badge: null,
    variants: [
      { name: 'Gray', image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?w=100&q=80' },
      { name: 'White', image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=100&q=80' }
    ]
  },
  4: {
    id: 4,
    title: 'Floor Cleaning Mop',
    price: 34.99,
    comparePrice: null,
    rating: 5.0,
    reviewCount: 89,
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&q=80',
    images: [
      'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&q=80'
    ],
    description: 'Revolutionary floor cleaning mop with microfiber pads. Cleans hardwood, tile, and laminate floors with just water. Extendable handle and machine-washable pads included.',
    badge: 'NEW',
    variants: [
      { name: 'Standard', image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=100&q=80' }
    ]
  },
  5: {
    id: 5,
    title: 'Bathroom Cleaning Set',
    price: 29.99,
    comparePrice: null,
    rating: 4.8,
    reviewCount: 456,
    image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=600&q=80',
    images: [
      'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=800&q=80',
      'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80'
    ],
    description: 'Complete bathroom cleaning solution with specialized cloths for mirrors, counters, and fixtures. Achieve a spa-like clean with zero chemicals.',
    badge: 'BEST SELLER',
    badgeType: 'bestseller',
    variants: [
      { name: 'White', image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=100&q=80' },
      { name: 'Blue', image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=100&q=80' }
    ]
  }
};

// ========================================
// HOTSPOT INTERACTIONS
// ========================================

function initHotspots() {
  const hotspotSection = document.querySelector('.achieve-happiness-hotspots');
  if (!hotspotSection) return;

  const dots = hotspotSection.querySelectorAll('.hotspot-dot');
  const tooltips = hotspotSection.querySelectorAll('.hotspot-tooltip');
  const productCard = hotspotSection.querySelector('.product-preview-card');

  let activeTooltip = null;

  // Dot click handlers
  dots.forEach(dot => {
    const productId = parseInt(dot.getAttribute('data-product-id'));
    const tooltip = hotspotSection.querySelector(`[data-tooltip-for="${productId}"]`);

    // Click handler - update product card
    dot.addEventListener('click', () => {
      // Update active state
      dots.forEach(d => d.classList.remove('active'));
      dot.classList.add('active');

      // Update product card
      updateProductCard(productId);
    });

    // Hover handlers for tooltip (desktop only)
    if (window.innerWidth >= 768) {
      dot.addEventListener('mouseenter', () => {
        if (tooltip) {
          positionTooltip(tooltip, dot);
          tooltip.classList.add('show');
          activeTooltip = tooltip;
        }
      });

      dot.addEventListener('mouseleave', () => {
        if (tooltip) {
          setTimeout(() => {
            if (activeTooltip === tooltip) {
              tooltip.classList.remove('show');
            }
          }, 200);
        }
      });
    }
  });

  // Initialize with first product
  updateProductCard(1);
}

// ========================================
// POSITION TOOLTIP
// ========================================

function positionTooltip(tooltip, dot) {
  const dotRect = dot.getBoundingClientRect();
  const tooltipRect = tooltip.getBoundingClientRect();
  const imageWrapper = dot.closest('.hotspot-image-wrapper');
  const wrapperRect = imageWrapper.getBoundingClientRect();

  // Calculate position relative to image wrapper
  const left = dotRect.left - wrapperRect.left;
  const top = dotRect.top - wrapperRect.top;

  // Position tooltip above dot
  tooltip.style.left = `${left}px`;
  tooltip.style.top = `${top - tooltipRect.height - 20}px`;
  tooltip.style.transform = 'translateX(-50%)';

  // Check if tooltip would go off screen
  const tooltipLeft = wrapperRect.left + left - (tooltipRect.width / 2);
  
  if (tooltipLeft < 0) {
    tooltip.style.transform = 'translateX(0)';
  } else if (tooltipLeft + tooltipRect.width > window.innerWidth) {
    tooltip.style.transform = 'translateX(-100%)';
  }

  // If near top, position below
  if (top < tooltipRect.height + 20) {
    tooltip.style.top = `${top + 50}px`;
  }
}

// ========================================
// UPDATE PRODUCT CARD - E-CLOTH STYLE
// ========================================

function updateProductCard(productId) {
  const product = hotspotProducts[productId];
  if (!product) return;

  const card = document.querySelector('.product-preview-card');
  if (!card) return;

  // Add updating class for transition
  card.classList.add('updating');

  setTimeout(() => {
    // Update image
    const image = card.querySelector('.product-preview__image');
    if (image) image.src = product.image;

    // Update badge
    const badge = card.querySelector('.product-preview__badge');
    if (badge) {
      if (product.badge) {
        badge.textContent = product.badge;
        badge.className = 'product-preview__badge badge';
        if (product.badgeType === 'sale') {
          badge.classList.add('badge-sale');
        } else if (product.badgeType === 'bestseller') {
          badge.classList.add('badge-bestseller');
        } else {
          badge.classList.add('badge-new');
        }
        badge.style.display = 'inline-flex';
      } else {
        badge.style.display = 'none';
      }
    }

    // Update rating (top of card)
    const ratingCount = card.querySelector('.product-preview__rating-top .rating-count');
    if (ratingCount) {
      ratingCount.textContent = product.rating.toFixed(1);
    }

    // Update bottom bar title
    const barTitle = card.querySelector('.product-bar__title');
    if (barTitle) barTitle.textContent = product.title;

    // Update bottom bar price
    const barPrice = card.querySelector('.product-bar__price');
    if (barPrice) {
      if (product.comparePrice) {
        barPrice.innerHTML = `<span style="text-decoration: line-through; color: var(--color-gray); font-size: 16px; margin-right: 8px;">$${product.comparePrice.toFixed(2)}</span>$${product.price.toFixed(2)}`;
      } else {
        barPrice.textContent = `$${product.price.toFixed(2)}`;
      }
    }

    // Remove updating class
    card.classList.remove('updating');
  }, 300);
}

// Variant selector removed - not needed in E-Cloth style bottom bar

// ========================================
// QUICK VIEW MODAL - E-CLOTH STYLE
// ========================================

function initQuickViewModal() {
  const modal = document.getElementById('quick-view-modal');
  if (!modal) return;

  const bottomBar = document.getElementById('product-bottom-bar');
  const productImage = document.getElementById('hotspot-image-clickable');
  const closeBtn = modal.querySelector('.quick-view-modal__close');
  const overlay = modal.querySelector('.quick-view-modal__overlay');

  // Get current active product
  function getCurrentProduct() {
    const activeDot = document.querySelector('.hotspot-dot.active');
    const productId = activeDot ? parseInt(activeDot.getAttribute('data-product-id')) : 1;
    return hotspotProducts[productId];
  }

  // Open modal from bottom bar or product image
  if (bottomBar) {
    bottomBar.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  }

  if (productImage) {
    productImage.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
    productImage.style.cursor = 'pointer';
  }

  function openModal() {
    const product = getCurrentProduct();
    updateModalContent(product);
    
    modal.classList.add('active');
    document.body.classList.add('modal-open');
    
    // Focus trap
    trapFocus(modal);
  }

  // Close modal
  function closeModal() {
    modal.classList.remove('active');
    document.body.classList.remove('modal-open');
    releaseFocus();
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  // ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });

  // Modal gallery thumbnails
  const modalThumbnails = modal.querySelectorAll('.modal-gallery__thumbnail');
  const modalMainImage = modal.querySelector('#modal-main-image');

  modalThumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      modalThumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      
      const img = thumb.querySelector('img');
      if (img && modalMainImage) {
        modalMainImage.src = img.src.replace('w=200', 'w=800');
      }
    });
  });
}

// ========================================
// UPDATE MODAL CONTENT
// ========================================

function updateModalContent(product) {
  const modal = document.getElementById('quick-view-modal');
  if (!modal || !product) return;

  // Update title
  const title = modal.querySelector('.modal-details__title');
  if (title) title.textContent = product.title;

  // Update rating
  const ratingCount = modal.querySelector('.modal-details__rating .rating-count');
  if (ratingCount) {
    ratingCount.textContent = `${product.rating} (${product.reviewCount} reviews)`;
  }

  // Update price
  const priceMain = modal.querySelector('.modal-details__price-main');
  const priceCompare = modal.querySelector('.modal-details__price-compare');
  
  if (priceMain) {
    priceMain.textContent = `$${product.price.toFixed(2)}`;
  }
  
  if (priceCompare) {
    if (product.comparePrice) {
      priceCompare.textContent = `$${product.comparePrice.toFixed(2)}`;
      priceCompare.style.display = 'inline';
    } else {
      priceCompare.style.display = 'none';
    }
  }

  // Update description
  const description = modal.querySelector('.modal-details__description');
  if (description) description.textContent = product.description;

  // Update main image
  const mainImage = modal.querySelector('#modal-main-image');
  if (mainImage && product.images && product.images[0]) {
    mainImage.src = product.images[0];
  }

  // Update gallery thumbnails
  const galleryNav = modal.querySelector('.modal-gallery__nav');
  if (galleryNav && product.images) {
    galleryNav.innerHTML = '';
    product.images.forEach((imgSrc, index) => {
      const thumb = document.createElement('div');
      thumb.className = `modal-gallery__thumbnail ${index === 0 ? 'active' : ''}`;
      thumb.innerHTML = `<img src="${imgSrc.replace('w=800', 'w=200')}" alt="Thumbnail ${index + 1}">`;
      galleryNav.appendChild(thumb);
      
      thumb.addEventListener('click', () => {
        modal.querySelectorAll('.modal-gallery__thumbnail').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (mainImage) mainImage.src = imgSrc;
      });
    });
  }

  // Update variants
  const variantOptions = modal.querySelector('.modal-details__variants .variant-selector__options');
  if (variantOptions && product.variants) {
    variantOptions.innerHTML = '';
    product.variants.forEach((variant, index) => {
      const button = document.createElement('button');
      button.className = 'variant-option';
      if (index === 0) button.classList.add('active');
      button.innerHTML = `<img src="${variant.image}" alt="${variant.name}">`;
      variantOptions.appendChild(button);
      
      button.addEventListener('click', () => {
        variantOptions.querySelectorAll('.variant-option').forEach(opt => opt.classList.remove('active'));
        button.classList.add('active');
      });
    });
  }
}

// ========================================
// FOCUS TRAP
// ========================================

let focusedElementBeforeModal;

function trapFocus(element) {
  focusedElementBeforeModal = document.activeElement;

  const focusableElements = element.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  element.addEventListener('keydown', function handleTabKey(e) {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          lastFocusable.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          firstFocusable.focus();
          e.preventDefault();
        }
      }
    }
  });

  firstFocusable.focus();
}

function releaseFocus() {
  if (focusedElementBeforeModal) {
    focusedElementBeforeModal.focus();
  }
}

// ========================================
// INITIALIZE
// ========================================

document.addEventListener('DOMContentLoaded', () => {
  initHotspots();
  initQuickViewModal();
  
  console.log('PURE SKY - Hotspot section initialized ✓');
});
